'use client';

import { LogoStrokedGradient } from 'assets/icons';
import { Container } from 'components/shared';
import CustomLink from 'components/shared/CustomLink';
import styles from './join-group-client.module.css';

const DownloadBtns = () => {
  return (
    <section className={styles.downloadBtns}>
      <Container>
        <p>Don&apos;t have the app?</p>
        <div className={styles.btnContainer}>
          <CustomLink href="https://apps.apple.com/us/app/ultrahuman-workout-sleep/id1491286709?_gl=1*18lhi3y*_gcl_au*MTE0OTU0ODE5Ni4xNjkzOTM1MjA4">
            Download for iPhone
          </CustomLink>
          <CustomLink href="https://play.google.com/store/apps/details?id=com.ultrahuman.android&_gl=1*18lhi3y*_gcl_au*MTE0OTU0ODE5Ni4xNjkzOTM1MjA4">
            Download for Android
          </CustomLink>
        </div>
      </Container>
    </section>
  );
};

export const Hero = ({ code }: { className?: string; code?: string }) => {
  const handleClick = () => {
    if (!window || !code) return;
    window.open(`ultrahuman://join_group?group_id=${code}`);
  };

  return (
    <section className={styles.hero}>
      <div className={styles.noiseBg} aria-hidden="true"></div>
      <Container className={styles.content}>
        <LogoStrokedGradient className={styles.uhLogo} />
        <h1>Ultrahuman Zones</h1>
        <p className={styles.subtitle}>
          Share and Celebrate Scores within your Zone
        </p>
        {code && (
          <>
            <button onClick={handleClick}>Open in Ultrahuman App</button>
          </>
        )}
      </Container>
    </section>
  );
};

const JoinGroup = ({ code }: { code?: string }) => {
  return (
    <>
      <Hero code={code} />
      <DownloadBtns />
    </>
  );
};

export default JoinGroup;
